import { NgModule } from '@angular/core';
import { FormatNameLengthPipe } from './call-cost.pipe';

@NgModule({
   declarations: [FormatNameLengthPipe],
   exports: [FormatNameLengthPipe],
})
export class FormatNameLengthPipeModule {}
